import * as LZString from "lz-string";

export const URL_STATE_PARAM = "view";

export type UrlStateSlices = Record<string, unknown>;

export function decodeUrlState(encodedState: string | null): UrlStateSlices {
  if (!encodedState) return {};

  try {
    const urlSafeEncodedState = encodedState.replace(/ /g, "+");
    const json = LZString.decompressFromEncodedURIComponent(urlSafeEncodedState);

    if (!json) return {};

    const parsed: unknown = JSON.parse(json);

    return isUrlStateSlices(parsed) ? parsed : {};
  } catch (error) {
    console.error("Failed to decode url state:", error);

    return {};
  }
}

export function encodeUrlState(slices: UrlStateSlices): string | undefined {
  if (Object.keys(slices).length === 0) return undefined;

  return LZString.compressToEncodedURIComponent(JSON.stringify(slices));
}

export function readUrlStateSlice<T>(searchParams: URLSearchParams, sliceKey: string): T | undefined {
  return decodeUrlState(searchParams.get(URL_STATE_PARAM))[sliceKey] as T | undefined;
}

export function withUrlStateSlice(searchParams: URLSearchParams, sliceKey: string, slice: unknown): URLSearchParams {
  const nextSearchParams = new URLSearchParams(searchParams.toString());
  const slices = decodeUrlState(nextSearchParams.get(URL_STATE_PARAM));

  if (slice === undefined) {
    delete slices[sliceKey];
  } else {
    slices[sliceKey] = slice;
  }

  return writeUrlState(nextSearchParams, slices);
}

function writeUrlState(searchParams: URLSearchParams, slices: UrlStateSlices): URLSearchParams {
  const encodedState = encodeUrlState(slices);

  if (encodedState) {
    searchParams.set(URL_STATE_PARAM, encodedState);
  } else {
    searchParams.delete(URL_STATE_PARAM);
  }

  return searchParams;
}

function isUrlStateSlices(value: unknown): value is UrlStateSlices {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
